(function () {

  // ── CSS ──────────────────────────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    .product-card__quick-buy .button,
    .product-card__quick-buy button {
      transition: opacity 0.2s ease, transform 0.2s ease !important;
    }
    .product-card__quick-buy .button:hover,
    .product-card__quick-buy button:hover {
      opacity: 0.82;
      transform: translateY(-1px);
    }
    .product-card__mobile-quick-buy-button[aria-busy="true"] .button__loader {
      display: flex !important;
      opacity: 1 !important;
    }
    .product-card__mobile-quick-buy-button[aria-busy="true"] > div {
      opacity: 0 !important;
    }
    .product-card__mobile-quick-buy-button {
      position: relative !important;
    }
    .product-card__mobile-quick-buy-button .button__loader {
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      display: flex;
      gap: 3px;
      align-items: center;
    }
    .product-card__mobile-quick-buy-button .button__loader span {
      width: 4px !important;
      height: 4px !important;
      border-radius: 50% !important;
      background: currentColor !important;
      display: inline-block !important;
      animation: qb-dot-blink 0.6s ease-in-out infinite alternate !important;
    }
    .product-card__mobile-quick-buy-button .button__loader span:nth-child(2) {
      animation-delay: 0.2s !important;
    }
    .product-card__mobile-quick-buy-button .button__loader span:nth-child(3) {
      animation-delay: 0.4s !important;
    }
    .product-form .button[type="submit"],
    .product-form button[type="submit"],
    buy-buttons .button,
    buy-buttons button[type="submit"] {
      transition: opacity 0.2s ease, transform 0.2s ease !important;
    }
    .product-form .button[type="submit"]:hover,
    .product-form button[type="submit"]:hover,
    buy-buttons .button:hover,
    buy-buttons button[type="submit"]:hover {
      opacity: 0.82;
      transform: translateY(-1px);
    }
    @keyframes qb-dot-blink {
      from { opacity: 1; transform: scale(1); }
      to   { opacity: 0.2; transform: scale(0.7); }
    }
  `;
  document.head.appendChild(style);

  // ── Touch prefetch only for quick buy ─────────────────────────────────────
  // Important: do NOT add to cart here.
  document.addEventListener('touchstart', function (e) {
    const btn = e.target.closest(
      '.product-card__mobile-quick-buy-button, .product-card__quick-buy .button'
    );
    if (!btn) return;

    const card = btn.closest('product-card');
    if (!card) return;
    const drawer = card.querySelector('quick-buy-drawer');
    if (drawer && typeof drawer.prefetch === 'function') {
      drawer.prefetch();
    }
  }, { passive: true });

  // ── Quick Buy click handler ───────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      '.product-card__quick-buy .button, .product-card__mobile-quick-buy-button'
    );
    if (!btn) return;

    btn.setAttribute('aria-busy', 'true');

    let attempts = 0;
    const poll = setInterval(function () {
      attempts++;
      const openDrawer = document.querySelector('quick-buy-drawer[open]');
      const pageLeaving = document.hidden;
      if (openDrawer || pageLeaving || attempts > 120) {
        clearInterval(poll);
        btn.removeAttribute('aria-busy');
      }
    }, 50);

  }, true);

  // ── Product page Add to Cart click handler ────────────────────────────────
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      'product-form button[type="submit"], buy-buttons button[type="submit"]'
    );
    if (!btn || btn.closest('.product-card__quick-buy')) return;

    btn.setAttribute('aria-busy', 'true');

    function onDone() {
      btn.removeAttribute('aria-busy');
      document.removeEventListener('cart:change', onDone);
      document.removeEventListener('cart:error', onDone);
    }
    document.addEventListener('cart:change', onDone);
    document.addEventListener('cart:error', onDone);
    setTimeout(onDone, 8000);

  }, true);

  // ── Quick buy drawer prefetch + hover ─────────────────────────────────────
  function applyFix() {
    const DrawerClass = customElements.get('quick-buy-drawer');
    if (!DrawerClass) return;
    const proto = DrawerClass.prototype;

    proto.prefetch = function () {
      if (this._hasLoaded || this._prefetchPromise) return;
      const handle = this.getAttribute('handle');
      if (!handle) return;
      this._prefetchPromise = fetch(
        window.Shopify.routes.root + 'products/' + handle.split('?')[0]
      ).then(r => r.text()).catch(() => { this._prefetchPromise = null; });
    };

    document.addEventListener('pointerover', function (e) {
      const quickBuyArea = e.target.closest('.product-card__quick-buy');
      if (!quickBuyArea) return;
      const card = quickBuyArea.closest('product-card');
      if (!card) return;
      const drawer = card.querySelector('quick-buy-drawer');
      if (drawer && typeof drawer.prefetch === 'function') {
        drawer.prefetch();
      }
    }, { passive: true });

    console.log('[QuickBuyFix] Applied ✓');
  }

  customElements.whenDefined('quick-buy-drawer').then(applyFix);

})();